// extracted by mini-css-extract-plugin
export default {"additionalSelector":"ColorsSelector_additionalSelector__+zFHz","mediaAssigned":"ColorsSelector_mediaAssigned__xyhfh","yellowDot":"ColorsSelector_yellowDot__6N7ab"};